let actionCodeBaseUrl = '';
if (process.env.REACT_APP_TARGET_ENV === 'local') {
  actionCodeBaseUrl = 'https://localhost:3000/';
}

if (process.env.REACT_APP_TARGET_ENV === 'development') {
  actionCodeBaseUrl = 'https://app.sellingbees.com/';
}

if (process.env.REACT_APP_TARGET_ENV === 'production') {
  actionCodeBaseUrl = 'https://app.dealcopilot.ai/';
}

// TODO: replace with the simulation app host
if (process.env.REACT_APP_TARGET_ENV === 'simulation') {
  actionCodeBaseUrl = 'https://demo.vibecloser.com/';
}

export default actionCodeBaseUrl;
